module.exports = __webpack_public_path__ + "img/noSetIco.ff53ff31.svg";